import { useNavigate } from 'react-router-dom';
import { FiPhone } from 'react-icons/fi';
import style from './CustomerCard.module.css';
import check from '../../assets/check28x28.png';

export function CustomerCard({ customer }) {
    const { name = '', phone = '' } = customer?.contact ?? {};
    const { quantity = 0, amount = 0 } = customer?.ordersInfo ?? {};

    const navigate = useNavigate();

    const handlePaymentClick = () => {
        navigate('/orders');
    };

    const status = customer?.customerStatus ?? '';

    const statusElements = {
        regular: <img src={check} alt="Постійний" />,
        standart: <div className={style.circle}></div>,
        newCustomer: <div className={style.rectangle}></div>,
    };

    const currentElement = statusElements[status];

    return (
        <div className={style.cardBlock}>
            <div className={style.customerBlock}>
                <div className={style.customerName}>
                    <div>{name}</div>
                    <div className={style.customerPhone}>
                        <FiPhone />
                        <span>{phone}</span>
                    </div>
                </div>
                <div className={style.customerStatus}>{currentElement || null}</div>
            </div>
            <div className={style.emrybu}>EMRYBU</div>
            <div className={style.customerFooter}>
                <div className={style.customerInfo}>
                    <div className={style.customerOrder}>Замовлень: {quantity}</div>
                    <div className={style.customerAmount}>Сума: {amount} UAH</div>
                </div>
                <button type="button" className={style.btnPayment} onClick={handlePaymentClick}>
                    <div>Мої</div>
                    <div>замовлення</div>
                </button>
            </div>
        </div>
    );
}
